(function () {
    'use strict';

    document.querySelectorAll('.tab-in-tab-block').forEach(function (block) {
        var tabButtons = block.querySelectorAll('.nav-tabs [data-bs-toggle="tab"]');
        var dropdown = block.querySelector('.dropdown[id^="parentDropdown-"]');
        var dropdownLabel = dropdown ? dropdown.querySelector('.dropdown-label') : null;
        var dropdownItems = dropdown ? dropdown.querySelectorAll('.dropdown-item[data-tab-target]') : [];
        var navWrapper = block.querySelector('.nav-wrapper');

        // Sync desktop tab to mobile dropdown label
        tabButtons.forEach(function (btn) {
            btn.addEventListener('shown.bs.tab', function (e) {
                if (dropdownLabel) dropdownLabel.textContent = e.target.textContent.trim();
                dropdownItems.forEach(function (item) {
                    item.classList.toggle('active', item.getAttribute('data-tab-target') === e.target.id);
                });
            });
        });

        // Mobile dropdown item switches tab pane
        dropdownItems.forEach(function (item) {
            item.addEventListener('click', function () {
                var tabBtn = block.querySelector('#' + this.getAttribute('data-tab-target'));
                if (!tabBtn) return;
                tabButtons.forEach(function (btn) {
                    btn.classList.remove('active');
                    btn.setAttribute('aria-selected', 'false');
                    var pane = block.querySelector(btn.getAttribute('data-bs-target'));
                    if (pane) pane.classList.remove('show', 'active');
                });
                tabBtn.classList.add('active');
                tabBtn.setAttribute('aria-selected', 'true');
                var pane = block.querySelector(tabBtn.getAttribute('data-bs-target'));
                if (pane) pane.classList.add('show', 'active');
                if (dropdownLabel) dropdownLabel.textContent = this.textContent.trim();
                dropdownItems.forEach(function (di) { di.classList.remove('active'); });
                this.classList.add('active');
            });
        });

        // Side-nav anchor smooth scroll
        block.querySelectorAll('.side-nav a.nav-link').forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                var target = document.getElementById(this.getAttribute('href').substring(1));
                if (!target) return;
                var offset = navWrapper ? navWrapper.offsetHeight + 25 : 80;
                window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
                var nav = this.closest('.side-nav');
                if (nav) nav.querySelectorAll('.nav-link').forEach(function (l) { l.classList.remove('active'); });
                this.classList.add('active');
            });
        });

        // Scroll spy throttled with rAF (desktop only — side-nav hidden on mobile)
        var ticking = false;
        var onScroll = function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                var activePane = block.querySelector('.tab-pane.active');
                if (activePane) {
                    var sections = activePane.querySelectorAll('.child-section');
                    var links = activePane.querySelectorAll('.side-nav a.nav-link');
                    if (sections.length && links.length) {
                        var offset = navWrapper ? navWrapper.offsetHeight + 45 : 100;
                        var currentId = '';
                        sections.forEach(function (section) {
                            var h = section.querySelector('h1, h2, h3, h4, h5, h6');
                            if ((h || section).getBoundingClientRect().top <= offset) currentId = section.getAttribute('id');
                        });
                        if (currentId) {
                            links.forEach(function (link) {
                                link.classList.toggle('active', link.getAttribute('href') === '#' + currentId);
                            });
                        }
                    }
                }
                ticking = false;
            });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
    });
})();
